export const mangaList = [
  {
    id: "han-001",
    title: "秘密课堂",
    author: "金导演",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20cover%20style%20illustration%20of%20a%20romance%20drama%20featuring%20a%20young%20couple%20in%20school%20uniform%2C%20soft%20pastel%20colors%2C%20clean%20anime%20art%20style%2C%20manhwa%20cover%20design%20with%20Korean%20title%20text%20placeholder%2C%20dreamy%20atmosphere%2C%20detailed%20character%20portraits%2C%20webtoon%20style%20cover%20art&width=600&height=800&seq=manga-han-001&orientation=portrait",
    category: "hanman",
    categoryLabel: "韩漫",
    tags: ["恋爱", "校园", "甜宠"],
    rating: 9.5,
    status: "连载中",
    description: "她以为这只是一份普通的家教兼职，却没想到学生竟然是学校里最神秘的那个他。两个世界的人，因为一堂秘密的私人课程，命运开始交织……心跳加速的师生恋，藏着无数甜蜜与酸涩的秘密。",
    chapters: 87,
    updateDate: "2026-08-03",
    views: 1258000,
    featured: true,
  },
  {
    id: "han-002",
    title: "财阀家的小儿子",
    author: "李正贤",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20business%20drama%20theme%2C%20handsome%20male%20lead%20in%20luxury%20suit%2C%20corporate%20office%20background%2C%20webtoon%20illustration%2C%20dramatic%20lighting%2C%20rich%20color%20palette%2C%20clean%20lineart%2C%20manhwa%20promotional%20cover%20style&width=600&height=800&seq=manga-han-002&orientation=portrait",
    category: "hanman",
    categoryLabel: "韩漫",
    tags: ["重生", "商战", "复仇"],
    rating: 9.7,
    status: "连载中",
    description: "被财阀家族抛弃的私生子，带着前世的记忆重生回到年轻时代。这一次，他要夺回属于自己的一切，让所有曾经看不起他的人付出代价。商场如战场，且看他如何一步步登上财阀之巅。",
    chapters: 124,
    updateDate: "2026-08-04",
    views: 2310000,
    featured: true,
  },
  {
    id: "han-003",
    title: "女神降临",
    author: "猫咪",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20comedy%20cover%20art%2C%20beautiful%20female%20lead%20with%20makeup%20transformation%20theme%2C%20before%20and%20after%20concept%2C%20vibrant%20colors%2C%20manhwa%20illustration%20style%2C%20school%20setting%2C%20popular%20webtoon%20cover%20design&width=600&height=800&seq=manga-han-003&orientation=portrait",
    category: "hanman",
    categoryLabel: "韩漫",
    tags: ["恋爱", "化妆", "逆袭"],
    rating: 9.3,
    status: "已完结",
    description: "因为长相平凡而饱受欺凌的女孩，通过神奇的化妆技术变成了校园女神。但当素颜的秘密面临暴露危机时，她能否守住来之不易的爱情与友情？",
    chapters: 156,
    updateDate: "2026-07-20",
    views: 4500000,
    featured: false,
  },
  {
    id: "han-004",
    title: "全知读者视角",
    author: "singNsong",
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20art%2C%20apocalyptic%20setting%20with%20survivors%2C%20male%20protagonist%20holding%20a%20glowing%20book%2C%20dramatic%20action%20pose%2C%20dark%20atmosphere%20with%20vibrant%20accents%2C%20webtoon%20style%20illustration%2C%20detailed%20background&width=600&height=800&seq=manga-han-004&orientation=portrait",
    category: "hanman",
    categoryLabel: "韩漫",
    tags: ["奇幻", "生存", "系统"],
    rating: 9.8,
    status: "连载中",
    description: "他是唯一读完那本3000多章网络小说的人。当小说中的末日场景变为现实，只有他知道接下来会发生什么。利用书中知识，他必须在这个崩坏的世界中活下来。",
    chapters: 210,
    updateDate: "2026-08-04",
    views: 5800000,
    featured: true,
  },
  {
    id: "han-005",
    title: "我独自升级",
    author: "Chugong",
    cover: "https://readdy.ai/api/search-image?query=Korean%20action%20fantasy%20manhwa%20cover%2C%20dark%20shadow%20warrior%20with%20glowing%20purple%20eyes%2C%20epic%20battle%20pose%2C%20monsters%20in%20background%2C%20dungeon%20theme%2C%20high%20contrast%20lighting%2C%20webtoon%20style%20art%2C%20powerful%20character%20design&width=600&height=800&seq=manga-han-005&orientation=portrait",
    category: "hanman",
    categoryLabel: "韩漫",
    tags: ["奇幻", "升级", "战斗"],
    rating: 9.9,
    status: "已完结",
    description: "在一个充满怪物的世界里，最弱的E级猎人成肖宇在一次几乎致命的双重 dungeon 中获得了神秘的'系统'，获得了无限升级的能力。从最弱到最强，他的逆袭之路就此开始。",
    chapters: 179,
    updateDate: "2026-06-15",
    views: 8900000,
    featured: true,
  },
  {
    id: "han-006",
    title: "她的私生活",
    author: "金成允",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20office%20romance%20theme%2C%20female%20protagonist%20with%20dual%20life%20concept%2C%20elegant%20art%20style%2C%20warm%20color%20palette%2C%20webtoon%20illustration%2C%20modern%20setting%2C%20professional%20attire&width=600&height=800&seq=manga-han-006&orientation=portrait",
    category: "hanman",
    categoryLabel: "韩漫",
    tags: ["恋爱", "职场", "喜剧"],
    rating: 8.9,
    status: "连载中",
    chapters: 67,
    updateDate: "2026-08-02",
    views: 980000,
    featured: false,
    description: "美术馆首席策展人成德美，表面上是个完美的职场女性，私下却是个狂热的偶像追星族。当新来的馆长发现了她的秘密，一段啼笑皆非的办公室恋情就此展开。",
  },
  {
    id: "riman-001",
    title: "咒术回战",
    author: "芥见下下",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%20style%2C%20shonen%20action%20theme%2C%20male%20protagonist%20with%20spiky%20hair%2C%20supernatural%20powers%2C%20dark%20fantasy%20atmosphere%2C%20dynamic%20action%20pose%2C%20manga%20volume%20cover%20design%2C%20vibrant%20colors&width=600&height=800&seq=manga-riman-001&orientation=portrait",
    category: "riman",
    categoryLabel: "日漫",
    tags: ["热血", "战斗", "咒术"],
    rating: 9.6,
    status: "连载中",
    description: "高中生虎杖悠仁吞下了诅咒之王两面宿傩的手指，从此踏入了咒术师的世界。为了收集散落的宿傩手指，他与伙伴们一起对抗诅咒，揭开隐藏在黑暗中的真相。",
    chapters: 268,
    updateDate: "2026-08-03",
    views: 12000000,
    featured: true,
  },
  {
    id: "riman-002",
    title: "间谍过家家",
    author: "远藤达哉",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20manga%20comedy%20cover%20art%2C%20family%20theme%20with%20spy%20dad%20assassin%20mom%20and%20psychic%20child%2C%20lighthearted%20tone%2C%20clean%20manga%20illustration%20style%2C%20warm%20colors%2C%20retro%20european%20setting&width=600&height=800&seq=manga-riman-002&orientation=portrait",
    category: "riman",
    categoryLabel: "日漫",
    tags: ["喜剧", "家庭", "间谍"],
    rating: 9.4,
    status: "连载中",
    description: "为了执行秘密任务，顶级间谍'黄昏'必须组建一个临时家庭。他找来了能读心的女儿和职业杀手妻子，三人各怀秘密却组成了最温暖的家庭。",
    chapters: 102,
    updateDate: "2026-08-02",
    views: 7800000,
    featured: true,
  },
  {
    id: "riman-003",
    title: "电锯人",
    author: "藤本树",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20manga%20cover%2C%20chainsaw%20man%20protagonist%20with%20chainsaw%20arms%20and%20head%2C%20gritty%20art%20style%2C%20urban%20night%20setting%2C%20blood%20and%20action%20theme%2C%20high%20contrast%2C%20manga%20volume%20cover%20design&width=600&height=800&seq=manga-riman-003&orientation=portrait",
    category: "riman",
    categoryLabel: "日漫",
    tags: ["黑暗", "奇幻", "动作"],
    rating: 9.5,
    status: "连载中",
    description: "背负着父亲留下的巨额债务，少年淀治与恶魔啵奇塔相依为命。在一次被杀害后，啵奇塔与他合为一体，赋予了淀治变身电锯人的能力。从此，他踏上了狩猎恶魔的不归路。",
    chapters: 178,
    updateDate: "2026-08-04",
    views: 6500000,
    featured: true,
  },
  {
    id: "riman-004",
    title: "葬送的芙莉莲",
    author: "山田钟人",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20fantasy%20manga%20cover%2C%20elf%20female%20mage%20protagonist%20in%20a%20peaceful%20journey%2C%20pastoral%20fantasy%20setting%2C%20melancholic%20but%20warm%20atmosphere%2C%20watercolor%20art%20style%2C%20adventure%20theme%2C%20beautiful%20landscape&width=600&height=800&seq=manga-riman-004&orientation=portrait",
    category: "riman",
    categoryLabel: "日漫",
    tags: ["奇幻", "冒险", "治愈"],
    rating: 9.7,
    status: "连载中",
    description: "勇者一行人打败魔王后的故事。精灵魔法使芙莉莲拥有漫长的生命，当伙伴们一个个老去离世，她才开始真正理解人类的情感与羁绊。一段关于生命、记忆与传承的温柔旅程。",
    chapters: 138,
    updateDate: "2026-07-30",
    views: 3200000,
    featured: false,
  },
  {
    id: "riman-005",
    title: "海贼王",
    author: "尾田荣一郎",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20pirate%20adventure%20manga%20cover%20art%2C%20straw%20hat%20boy%20protagonist%20with%20crew%2C%20ocean%20background%2C%20treasure%20theme%2C%20vibrant%20colors%2C%20classic%20shonen%20manga%20style%2C%20epic%20adventure%20feeling&width=600&height=800&seq=manga-riman-005&orientation=portrait",
    category: "riman",
    categoryLabel: "日漫",
    tags: ["冒险", "热血", "友情"],
    rating: 9.8,
    status: "连载中",
    description: "少年路飞戴着草帽，怀揣成为海贼王的梦想踏上了伟大航路。一路上他召集了志同道合的伙伴，面对无数强敌与冒险，朝着最终之岛Laugh Tale不断前进。",
    chapters: 1120,
    updateDate: "2026-08-04",
    views: 25000000,
    featured: true,
  },
  {
    id: "riman-006",
    title: "蓝色监狱",
    author: "金城宗幸",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20sports%20manga%20cover%2C%20soccer%20theme%2C%20intense%20male%20player%20with%20determined%20expression%2C%20stadium%20background%2C%20dynamic%20action%20pose%2C%20blue%20color%20scheme%2C%20competitive%20atmosphere%2C%20manga%20volume%20cover%20style&width=600&height=800&seq=manga-riman-006&orientation=portrait",
    category: "riman",
    categoryLabel: "日漫",
    tags: ["运动", "竞技", "足球"],
    rating: 9.2,
    status: "连载中",
    chapters: 286,
    updateDate: "2026-08-01",
    views: 4100000,
    featured: false,
    description: "为了培养世界第一的前锋，日本足协启动了蓝色监狱计划。300名高中前锋被关进封闭设施，通过残酷的淘汰赛制，只选出最自私、最强的那一个。",
  },
  {
    id: "guo-001",
    title: "斗破苍穹",
    author: "天蚕土豆 / 任翔",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20martial%20arts%20fantasy%20cover%20art%2C%20young%20martial%20artist%20male%20protagonist%20with%20flaming%20aura%2C%20ancient%20Chinese%20setting%2C%20epic%20cultivation%20theme%2C%20dramatic%20composition%2C%20detailed%20character%20design%2C%20manhua%20full%20color%20illustration&width=600&height=800&seq=manga-guo-001&orientation=portrait",
    category: "guoman",
    categoryLabel: "国漫",
    tags: ["玄幻", "热血", "升级"],
    rating: 9.4,
    status: "连载中",
    description: "天才少年萧炎在创造了家族空前绝后的修炼纪录后，一夜之间斗气尽失沦为废人。就在他绝望之际，一缕灵魂从他手上的戒指里浮现，一扇全新的大门就此开启。",
    chapters: 512,
    updateDate: "2026-08-04",
    views: 18000000,
    featured: true,
  },
  {
    id: "guo-002",
    title: "一人之下",
    author: "米二",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20supernatural%20action%20cover%2C%20modern%20urban%20fantasy%20setting%2C%20male%20and%20female%20protagonists%20with%20supernatural%20powers%2C%20Chinese%20martial%20arts%20elements%2C%20full%20color%20manhua%20illustration%2C%20dynamic%20composition&width=600&height=800&seq=manga-guo-002&orientation=portrait",
    category: "guoman",
    categoryLabel: "国漫",
    tags: ["奇幻", "都市", "异能"],
    rating: 9.6,
    status: "连载中",
    description: "普通大学生张楚岚因爷爷的坟墓被盗而卷入异人世界，结识了神秘少女冯宝宝。在这个异能者云集的世界里，他逐渐揭开自己身世的秘密和爷爷留下的惊天谜团。",
    chapters: 680,
    updateDate: "2026-08-03",
    views: 9500000,
    featured: true,
  },
  {
    id: "guo-003",
    title: "狐妖小红娘",
    author: "小新",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20romance%20fantasy%20cover%20art%2C%20fox%20spirit%20female%20lead%20with%20traditional%20Chinese%20clothing%2C%20love%20story%20theme%2C%20beautiful%20ancient%20Chinese%20aesthetic%2C%20full%20color%20manhua%20illustration%2C%20dreamy%20atmosphere&width=600&height=800&seq=manga-guo-003&orientation=portrait",
    category: "guoman",
    categoryLabel: "国漫",
    tags: ["恋爱", "奇幻", "古风"],
    rating: 9.5,
    status: "连载中",
    description: "在人妖共存的架空世界中，狐妖小红娘涂山苏苏专门为人与妖之间的姻缘牵线。每一段跨越种族的爱情，都在她的帮助下开花结果，而她自己也在慢慢成长。",
    chapters: 420,
    updateDate: "2026-08-02",
    views: 7800000,
    featured: false,
  },
  {
    id: "guo-004",
    title: "镖人",
    author: "许先哲",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20historical%20action%20cover%2C%20warrior%20with%20sword%20in%20desert%20setting%2C%20ancient%20Chinese%20martial%20arts%20theme%2C%20gritty%20realistic%20art%20style%2C%20Tang%20dynasty%20aesthetic%2C%20full%20color%20detailed%20illustration&width=600&height=800&seq=manga-guo-004&orientation=portrait",
    category: "guoman",
    categoryLabel: "国漫",
    tags: ["武侠", "历史", "硬核"],
    rating: 9.8,
    status: "连载中",
    description: "隋末唐初，江湖刀客刀马带着幼子行走西域，以镖客身份卷入了一场牵动天下命运的大阴谋。硬核的武侠画风，真实的历史背景，演绎一段荡气回肠的侠义传奇。",
    chapters: 112,
    updateDate: "2026-07-28",
    views: 5600000,
    featured: true,
  },
  {
    id: "guo-005",
    title: "完美世界",
    author: "辰东 / 阿 Shu",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20cultivation%20fantasy%20cover%2C%20young%20male%20cultivator%20with%20glowing%20spiritual%20energy%2C%20ancient%20Chinese%20mythological%20creatures%2C%20epic%20scale%2C%20full%20color%20manhua%20art%2C%20dramatic%20heavenly%20backdrop&width=600&height=800&seq=manga-guo-005&orientation=portrait",
    category: "guoman",
    categoryLabel: "国漫",
    tags: ["玄幻", "修仙", "热血"],
    rating: 9.3,
    status: "连载中",
    chapters: 380,
    updateDate: "2026-08-04",
    views: 12000000,
    featured: false,
    description: "一粒尘可填海，一根草斩尽日月星辰。少年石昊从大荒中走出，以凡体逆天修行，在万族林立的完美世界中，一路披荆斩棘，登临绝巅，谱写一曲不朽的传奇。",
  },
  {
    id: "guo-006",
    title: "镇魂街",
    author: "许辰",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20supernatural%20action%20cover%2C%20guardian%20spirit%20warrior%20theme%2C%20modern%20urban%20mixed%20with%20ancient%20Chinese%20elements%2C%20male%20lead%20with%20spirit%20companion%2C%20full%20color%20manhua%20illustration%2C%20dramatic%20composition&width=600&height=800&seq=manga-guo-006&orientation=portrait",
    category: "guoman",
    categoryLabel: "国漫",
    tags: ["奇幻", "热血", "守护"],
    rating: 9.1,
    status: "连载中",
    chapters: 350,
    updateDate: "2026-07-31",
    views: 6200000,
    featured: false,
    description: "普通大学生夏铃误入镇魂街，一个连接人界与灵域的神秘之地。在这里，她遇到了拥有守护灵的镇魂将曹焱兵，从此开启了一段守护人界安宁的奇幻冒险。",
  },
];

export const categories = [
  { key: "hanman", label: "韩漫推荐", subLabel: "韩漫排行榜实时更新", icon: "ri-heart-pulse-line" },
  { key: "riman", label: "日漫系列", subLabel: "日漫全集下拉畅读", icon: "ri-fire-line" },
  { key: "guoman", label: "国漫精选", subLabel: "国漫大图高清全彩", icon: "ri-star-line" },
];

export const categorySubNav = {
  hanman: [
    { key: "all", label: "全部韩漫" },
    { key: "romance", label: "恋爱甜宠" },
    { key: "fantasy", label: "奇幻冒险" },
    { key: "action", label: "动作热血" },
    { key: "drama", label: "剧情悬疑" },
  ],
  riman: [
    { key: "all", label: "全部日漫" },
    { key: "shonen", label: "少年热血" },
    { key: "comedy", label: "搞笑日常" },
    { key: "fantasy", label: "奇幻异世界" },
    { key: "sports", label: "运动竞技" },
  ],
  guoman: [
    { key: "all", label: "全部国漫" },
    { key: "xuanhuan", label: "玄幻修仙" },
    { key: "wuxia", label: "武侠江湖" },
    { key: "urban", label: "都市异能" },
    { key: "romance", label: "古风恋爱" },
  ],
};

export const rankings = {
  hanman: ["han-004", "han-005", "han-002", "han-001", "han-003"],
  riman: ["riman-001", "riman-005", "riman-003", "riman-002", "riman-004"],
  guoman: ["guo-001", "guo-002", "guo-004", "guo-003", "guo-005"],
};

export const heroSlides = [
  {
    id: "han-004",
    title: "全知读者视角",
    subtitle: "韩漫奇幻巅峰之作 · 9.8分神作",
    description: "当小说中的末日场景变为现实，唯一读过结局的他，将如何改变世界？",
    cover: "https://readdy.ai/api/search-image?query=Epic%20Korean%20fantasy%20manhwa%20scene%2C%20apocalyptic%20cityscape%20with%20a%20lone%20survivor%20holding%20a%20glowing%20ancient%20book%2C%20dramatic%20lighting%20with%20orange%20and%20teal%20contrast%2C%20cinematic%20composition%2C%20massive%20scale%2C%20dust%20particles%20in%20air%2C%20webtoon%20art%20style%20inspired%20cinematic%20illustration&width=1600&height=700&seq=hero-slide-01&orientation=landscape",
    category: "hanman",
  },
  {
    id: "riman-001",
    title: "咒术回战",
    subtitle: "日本现象级热血漫画 · 全球销量破亿",
    description: "诅咒之王的手指，开启一段惊心动魄的咒术之旅",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20shonen%20manga%20cinematic%20scene%2C%20young%20sorcerer%20in%20urban%20Tokyo%20at%20night%2C%20supernatural%20cursed%20energy%20flowing%20around%2C%20dynamic%20action%20composition%2C%20dark%20atmosphere%20with%20vibrant%20blue%20energy%20accents%2C%20cinematic%20lighting%2C%20anime%20style%20illustration&width=1600&height=700&seq=hero-slide-02&orientation=landscape",
    category: "riman",
  },
  {
    id: "guo-004",
    title: "镖人",
    subtitle: "国漫硬核武侠天花板 · 9.8分口碑炸裂",
    description: "隋末乱世，一柄刀，一个人，护镖亦是护天下",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20martial%20arts%20cinematic%20scene%2C%20lone%20warrior%20with%20sword%20riding%20through%20vast%20desert%20under%20setting%20sun%2C%20ancient%20Tang%20dynasty%20aesthetic%2C%20dust%20and%20wind%2C%20epic%20scale%2C%20cinematic%20composition%2C%20realistic%20detailed%20art%20style&width=1600&height=700&seq=hero-slide-03&orientation=landscape",
    category: "guoman",
  },
];